const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000/api/v1';

export const env = {
  apiBaseUrl: apiBaseUrl.replace(/\/$/, ''),
  appName: import.meta.env.VITE_APP_NAME || 'AS DataLink',
  isDev: import.meta.env.DEV,
} as const;
